import { isValid } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import { calendarLocale } from '@/utils/helpers/calendar-locale';

const formatDate = (date: Date, useLocale?: boolean) => {
  if (!date || !isValid(date)) {
    return '';
  }

  return formatInTimeZone(date, 'Europe/Zurich', 'dd MMM yyyy', {
    locale: useLocale ? calendarLocale : undefined,
  });
};

export default formatDate;
